import { HttpErrorResponse } from "@angular/common/http";

export class JWTError extends Error {
  public constructor(error: HttpErrorResponse) {
    super(error.message);
  }
}
